
<div class="header" :style="bgc">
  <b-col>
    <b-row class="topheader-container">
      <h5 class="application-sub-heading">
        <p
          v-if="applicationSubHeading && applicationSubHeading.length > 0"
          class="applicationSubHeading"
        >
          {{ applicationSubHeading }}
        </p>
      </h5>
      <div class="topheader">
        <div id="logo" class="top-header-left-flex">
          <a :href="config_WebCaatAuthWebUrl" class="d-flex">
            <img src="@/assets/images/mms_logo_white.svg" alt="MMS Logo" />
          </a>
          <h1 class="env-text">{{ environment }}</h1>
        </div>
        <div class="top-header-middle">
          <div class="text-white webtools-horizontal">
            <!-- Loop through apps and render AppNavItem for each -->
            <app-nav-item
              v-for="(app, index) in apps"
              :key="app.id"
              :app-id="app.id"
              :app-data="app"
              :is-current-app="currentApp === app.id"
              :app-index="index"
              :progress-offset="progressOffset"
              :app-link="
                app.configLinkKey ? getAppLink(app.configLinkKey) : '#'
              "
              :icon-src="app.iconSrc"
              :header-background-color="config_BackgroundColor"
              :show-info-icon="app.showInfoIcon"
              @start-hover="startHover"
              @stop-hover="stopHover"
            />
          </div>
        </div>
        <div class="top-header-right-flex contextmenu-container">
          <div class="webtools-dropdown-container">
            <b-dropdown
              id="dropdown-2"
              text="More tools"
              class="m-2 webtools-dropdown"
            >
              <!-- Render all apps except Portalen above the divider -->
              <template v-for="app in apps.filter(a => a.id !== 'portal')">
                <app-dropdown-item
                  :key="app.id + '-dropdown'"
                  :is-current-app="currentApp === app.id"
                  :icon-src="
                    currentApp === app.id ? app.iconSrc : app.iconSrcBlue
                  "
                  :label="app.title"
                  :app-link="
                    app.configLinkKey ? getAppLink(app.configLinkKey) : '#'
                  "
                />
              </template>

              <b-dropdown-divider></b-dropdown-divider>

              <!-- Render only Portalen below the divider -->
              <template v-for="app in apps.filter(a => a.id === 'portal')">
                <app-dropdown-item
                  :key="app.id + '-dropdown'"
                  :is-current-app="currentApp === app.id"
                  :icon-src="
                    currentApp === app.id ? app.iconSrc : app.iconSrcBlue
                  "
                  :label="app.title"
                  :app-link="
                    app.configLinkKey ? getAppLink(app.configLinkKey) : '#'
                  "
                />
              </template>
            </b-dropdown>
          </div>
          <b-dropdown
            id="dropdown-1"
            split
            :text="$store.getters.getUser"
            class="contextmenu-login"
          >
            <b-dropdown-item @click="logout">Log out</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </b-row>
  </b-col>
</div>
